import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/common.service';
import { Profile, PaymentMethod, PaymentInfo } from 'profile-api';
import { ConfigurationVariablesList } from 'std-api';
import { GetCreditCardName } from '../utils/credit-card-name-getter';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StripeService } from 'ngx-stripe';
import { PaymentIntent } from '@stripe/stripe-js';

@Component({
    selector: 'app-buy-prepaid-packet',
    templateUrl: './buy-prepaid-packet.component.html',
    styleUrls: ['./buy-prepaid-packet.component.css']
})
export class BuyPrepaidPacketComponent implements OnInit {

    profile: Profile = {};
    paymentMethod: PaymentMethod = {};
    prepaidCreditSize: number;
    prepaidCreditPrice: number;
    prepaidCreditValidity: string;
    preapidCreditDescription: string;
    creditCardName: string;
    fromTender: boolean = false;
    fromQuoteBuy: boolean = false;
    fromParticipationBuy: boolean = false;
    isTenderPacket: boolean = false;
    error: string = "no_error";
    loading: boolean = false;

    privacyForm = new FormGroup({
        conditions: new FormControl('', [Validators.required]),
        privacy: new FormControl('', [Validators.required])
    });

    constructor(
        private commonService: CommonService,
        private route: ActivatedRoute,
        private router: Router,
        private stripeService: StripeService
    ) { }

    ngOnInit(): void {
        window['moment'] = moment;

        this.route.queryParams.subscribe(params => {
            if (params['fromTender']) {
                this.fromTender = true;
                this.isTenderPacket = true;
            }
            if (params['fromQuoteBuy']) {
                this.fromQuoteBuy = true;
                this.isTenderPacket = true;
            }
            let isTender = params['isTenderPacket'];
            if (isTender) {
                if (isTender === 'true') {
                    this.isTenderPacket = true;
                } else {
                    this.isTenderPacket = false;
                }
            }
            if (params['fromParticipationBuy']) {
                this.fromParticipationBuy = true;
                this.isTenderPacket = false;
            }
        });

        this.commonService.getProfile().then((profile: Profile) => {
            this.profile = profile;
            this.getPrepaidPacketInfo();
            this.getPaymentMethod();
        });

    }

    getPrepaidPacketInfo() {
        this.commonService.getConfigurationVariables().then(
            (variables: ConfigurationVariablesList) => {
                if (this.isTenderPacket) {
                    if (this.profile.privateRegistry || this.fromQuoteBuy) {
                        this.prepaidCreditSize = variables['PREPAID_PRI_CREDIT_DEFAULT_SIZE'];
                        this.prepaidCreditPrice = variables['PREPAID_PRI_CREDIT_DEFAULT_PRICE'];
                        let prepaidCreditValidityMonth = variables['PREPAID_PRI_CREDIT_DEFAULT_VALIDITY'];
                        this.prepaidCreditValidity = moment().add(prepaidCreditValidityMonth, 'months').format('DD-MM-YYYY');
                        this.preapidCreditDescription = "PrepaidCreditsType=PRI";
                    } else if (this.profile.prepaidCredits.professionalRegistrySubscriber) {
                        this.prepaidCreditSize = variables['PREPAID_REG_CREDIT_DEFAULT_SIZE'];
                        this.prepaidCreditPrice = variables['PREPAID_REG_CREDIT_DEFAULT_PRICE'];
                        let prepaidCreditValidityMonth = variables['PREPAID_REG_CREDIT_DEFAULT_VALIDITY'];
                        this.prepaidCreditValidity = moment().add(prepaidCreditValidityMonth, 'months').format('DD-MM-YYYY');
                        this.preapidCreditDescription = "PrepaidCreditsType=REG";
                    } else {
                        this.prepaidCreditSize = variables['PREPAID_STD_CREDIT_DEFAULT_SIZE'];
                        this.prepaidCreditPrice = variables['PREPAID_STD_CREDIT_DEFAULT_PRICE'];
                        let prepaidCreditValidityMonth = variables['PREPAID_STD_CREDIT_DEFAULT_VALIDITY'];
                        this.prepaidCreditValidity = moment().add(prepaidCreditValidityMonth, 'months').format('DD-MM-YYYY');
                        this.preapidCreditDescription = "PrepaidCreditsType=STD";
                    }
                } else {
                    this.prepaidCreditSize = variables['PREPAID_PAR_CREDIT_DEFAULT_SIZE'];
                    this.prepaidCreditPrice = variables['PREPAID_PAR_CREDIT_DEFAULT_PRICE'];
                    let prepaidCreditValidityMonth = variables['PREPAID_PAR_CREDIT_DEFAULT_VALIDITY'];
                    this.prepaidCreditValidity = moment().add(prepaidCreditValidityMonth, 'months').format('DD-MM-YYYY');
                    this.preapidCreditDescription = "PrepaidCreditsType=PAR";
                }
            }
        );
    }

    getPaymentMethod() {
        this.loading = true;
        this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
            (paymentMethod: PaymentMethod) => {
                this.loading = false;
                this.paymentMethod = paymentMethod;
                this.creditCardName = GetCreditCardName(paymentMethod.creditCardBrand);
            },
            (error) => {
                this.loading = false;
                this.error = "Si è verificato un errore durante il caricamento della carta di credito.";
                console.log(error);
            }
        )
    }

    purchaseCreditPost() {
        if (this.isTenderPacket) {
            this.commonService.getPrepaidCreditsService().profilePurchaseCreditsPost().subscribe(
                (profile: Profile) => {
                    //refresh profile 
                    localStorage.setItem('PROFILE_DATE', new Date().toString());
                    localStorage.setItem('PROFILE', JSON.stringify(profile));
                    this.loading = false;
                    if (this.fromTender) {
                        this.router.navigate(['/acquistacreazionegara']);
                    } else if (this.fromQuoteBuy) {
                        this.router.navigate(['/acquistarichiestapreventivo']);
                    } else {
                        this.goToThanksPage(null);
                    }
                },
                (error) => {
                    this.loading = false;
                    this.goToThanksPage(error);
                }
            );
        } else {
            this.commonService.getPrepaidCreditsService().profilePurchaseParticipationCreditsPost().subscribe(
                (profile: Profile) => {
                    //refresh profile 
                    localStorage.setItem('PROFILE_DATE', new Date().toString());
                    localStorage.setItem('PROFILE', JSON.stringify(profile));
                    this.loading = false;
                    if (this.fromParticipationBuy) {
                        this.router.navigate(['/acquistapartecipazioneallagara']);
                    } else {
                        this.goToThanksPage(null);
                    }
                },
                (error) => {
                    this.loading = false;
                    this.goToThanksPage(error);
                }
            );
        }
    }

    purchaseCredit() {
        if (!this.privacyForm.valid || this.privacyForm.get('privacy').value === false || this.privacyForm.get('conditions').value === false) {
            this.error = "Per poter procedere è necessario prendere visione delle condizioni generali e della privacy.";
            console.log("Invalid privacy form");
            return;
        } else {
            this.error = "no_error";
        }
        
        this.loading = true;
        const transactionInfo = { amount: this.prepaidCreditPrice, description: this.preapidCreditDescription } as PaymentInfo;

        this.commonService.getPaymentMethodService().profileStripePaymentIntentPost(transactionInfo).subscribe(
            () => {
                //Payment succesfully directly on server. Purchase credit
                this.purchaseCreditPost();
            },
            (error) => {
                if (error.error.cardExceptionErrorCode === 'authentication_required') {
                    this.confirmCardPayment(error.error.clientSecret, error.error.paymentMethodId);
                } else {
                    this.loading = false;
                    this.goToThanksPage(error.error.cardExceptionError);
                }
            }
        );
    }

    confirmCardPayment(clientSecret: string, paymentMethodId: string) {
        this.stripeService.confirmCardPayment(clientSecret, {
            payment_method: paymentMethodId
        }).subscribe(
            (value: { paymentIntent: PaymentIntent, error: any }) => {
                if (value.paymentIntent) {
                    //Client authorization sucess. Go to thanks page
                    this.purchaseCreditPost();
                } else {
                    //Payment intent is null when customer close authentication window without proceede to authenticate
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                this.goToThanksPage(error.error.cardExceptionError);
            }
        );
    }

    goToThanksPage(error: string) {
        if (error) {
            localStorage.setItem('BUY_PREPAID_PACKET_ERROR', error);
        } else {
            localStorage.removeItem('BUY_PREPAID_PACKET_ERROR');
        }
        this.router.navigate(['/grazieacquistopacchetto'], { queryParams: { "isTenderPacket":  this.isTenderPacket}});
    }

}
